import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import {
  Pdv39Form,
  PdvEvidencijaPojedinacnaService,
} from '../pdv-evidencija-pojedinacna.service';
import { PdvEvidencijaPojedinacnaForm39Service } from '../pdv-evidencija-pojedinacna39-form.service';
import { ActivatedRoute } from '@angular/router';
import {
  CreatePdvEvidencijaPojedinacna39Command,
  IStrankaForPdvDto,
  IVezaniRacunDto,
  PdvEvidencijaOsnovOdabiraDokumenta,
  PdvEvidencijaTipDokumenta,
  PdvEvidencijaTipPovezaneFakture,
  PdvEvidencijaTipPovezanogInternog,
  PdvEvidencijeClient,
  SefKorigujPdvEvidencijaPojedinacna39Command,
  TipRacuna,
  UpdatePdvEvidencijaPojedinacna39Command,
  VrstaRacuna,
} from '@kodit/core/data-api';
import {
  FormHelper,
  VezaniRacunFormService,
} from '@kodit/core/form-definitions';
import { ConfirmationService } from 'primeng/api';
import {
  AlertService,
  LocationService,
  SharedService,
} from '@kodit/core/services';
import {
  AbstractControl,
  FormArray,
  FormControl,
  Validators,
} from '@angular/forms';
import { TipPovezanogDokumentaDropdownComponent } from '../../ui/tip-povezanog-dokumenta-dropdown/tip-povezanog-dokumenta-dropdown.component';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'kodit-pdv-evidencija-pojedinacna39-form',
  templateUrl: './pdv-evidencija-pojedinacna39-form.component.html',
  styleUrls: ['./pdv-evidencija-pojedinacna39-form.component.scss'],
})
export class PdvEvidencijaPojedinacna39FormComponent
  implements OnInit, OnDestroy {
  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Props */
  form!: Pdv39Form;
  useOnlyTipove: TipRacuna[] | undefined;
  shouldDisableForm: boolean = false;
  tipDokumenta = PdvEvidencijaTipDokumenta;
  tipPovezaneFakture = PdvEvidencijaTipPovezaneFakture;
  tipPovezanogInternog = PdvEvidencijaTipPovezanogInternog;
  promet = VrstaRacuna;
  osnovOdabira = PdvEvidencijaOsnovOdabiraDokumenta;
  shouldLabelBeAvans: boolean = false;
  shouldDisplayIsporukaBN = true;
  shouldDisplayNabavkaBN = true;
  isKoriguj: boolean;
  disabledTipPovezanog: boolean = false;
  poreskiBrojPostojiUBazi: boolean = true;

  /** I/O */
  @ViewChild('avansniVanSefaInput') avansniVanSefaInput!: ElementRef;

  constructor(
    private _fs: PdvEvidencijaPojedinacnaForm39Service,
    private _route: ActivatedRoute,
    private _formHelper: FormHelper,
    public _pdvPojedinacnaService: PdvEvidencijaPojedinacnaService,
    private _confirmationService: ConfirmationService,
    private _locationService: LocationService,
    private _sharedService: SharedService,
    private _client: PdvEvidencijeClient,
    private _alert: AlertService,
    private _vezaniRacunFS: VezaniRacunFormService
  ) {
    this.isKoriguj = false;
  }

  ngOnInit(): void {
    this.shouldDisableForm = this._route.snapshot.data['isPregledKorigovane'];
    this.isKoriguj = this._route.snapshot.data['isKoriguj'];
    this.form = this._fs.getForm(
      this._route.snapshot.data['evidencija'],
      this.isKoriguj
    );
    this.loadOsnovOdabiraProps();
    this.poreskiBrojPostojiUBazi =
      !!this.form?.controls.stranka?.get('poreskiBrojStranogLica')?.value;
    this._postaviValidatorPoreskogBroja(this.form?.value.tip);

    this._subs.add(
      this.form?.controls.tip?.valueChanges.subscribe((tip) => {
        this._postaviValidatorPoreskogBroja(tip);
      })
    );

    this._subs.add(
      this.form?.controls.tipPovezaneFakture?.valueChanges.subscribe(
        (value) => {
          if (value === this.tipPovezaneFakture.VREMENSKI_PERIOD) {
            this.form?.controls.vremenskiPeriodPocetak?.addValidators(
              Validators.required
            );
            this.form?.controls.vremenskiPeriodZavrsetak?.addValidators(
              Validators.required
            );

            return;
          }
          this.form?.controls.vremenskiPeriodPocetak?.patchValue(null);
          this.form?.controls.vremenskiPeriodPocetak?.clearValidators();
          this.form?.controls.vremenskiPeriodZavrsetak?.patchValue(null);
          this.form?.controls.vremenskiPeriodZavrsetak?.clearValidators();
        }
      )
    );

    this._avansLabelsInit();
    this._pdvPojedinacnaService.setDokumentBrojChanged = this.form!.controls.stranka?.value?.naziv ?? "";
    this._subs.add(
      this._pdvPojedinacnaService.getDisabledTipPovezanogObservable.subscribe(res => {
        if(res){
          this.disabledTipPovezanog = true;
        }else{
          this.disabledTipPovezanog = false;
        }
      })
    );

    if(this.form!.controls.povezaniRacuni?.value && this.form!.controls.povezaniRacuni?.value.length > 0){
      this.disabledTipPovezanog = true;
    }

    this._subs.add(
      this._pdvPojedinacnaService.povezaniDokument$.subscribe((dok) => {
        if (!dok) {
          return;
        }
        this.poreskiBrojPostojiUBazi = !!dok.stranka?.poreskiBrojStranogLica;

        const jeIsporuka = dok.smer === VrstaRacuna.IZLAZNI;
        this._pdvPojedinacnaService.setIsIsporuka = jeIsporuka;
        this.form!.controls.smer?.patchValue(dok.smer);
        if (!jeIsporuka) {
          const tipDokumenta = dok.jeInostranaFaktura
            ? PdvEvidencijaTipDokumenta.INTERNI_RACUN_ZA_PROMET_STRANOG_LICA
            : PdvEvidencijaTipDokumenta.DRUGI_INTERNI_RACUN;
          this.form!.controls.tip?.patchValue(tipDokumenta);
          this._pdvPojedinacnaService.setTipDokumentaSubject = tipDokumenta;
        }
        this._pdvPojedinacnaService.setPovezaniDokument(dok);
      })
    );

    this._subs.add(
      this.form!.controls.povezanaFaktura?.valueChanges.subscribe((v: any) => {
        if (!this._pdvPojedinacnaService.getIsIsporuka) {
          this.form!.controls.brojDokumentaNabavka?.patchValue(v?.broj ?? null, {
            emitEvent: false,
          });
        }
      })
    );

  }

  onStrankaChange(stranka: IStrankaForPdvDto | undefined) {
    this.poreskiBrojPostojiUBazi = !!stranka?.poreskiBrojStranogLica;
  }

  get jePrometStranogLica(): boolean {
    return (
      this.form?.value.tip ===
      PdvEvidencijaTipDokumenta.INTERNI_RACUN_ZA_PROMET_STRANOG_LICA
    );
  }

  get identifikatorLicaCtrl(): AbstractControl {
    return this.jePrometStranogLica
      ? this.form!.controls.stranka!.get('poreskiBrojStranogLica')!
      : this.form!.controls.stranka!.get('pibOrJbkjs')!;
  }

  get jePoreskiBrojZakljucan(): boolean {
    if (this.shouldDisableForm || !this.jePrometStranogLica) {
      return true;
    }

    return this.poreskiBrojPostojiUBazi;
  }

  private _postaviValidatorPoreskogBroja(tip: PdvEvidencijaTipDokumenta | undefined) {
    const ctrl = this.form?.controls.stranka?.get('poreskiBrojStranogLica');

    if (!ctrl) {
      return;
    }

    if (tip === PdvEvidencijaTipDokumenta.INTERNI_RACUN_ZA_PROMET_STRANOG_LICA) {
      ctrl.addValidators(Validators.required);
    } else {
      ctrl.removeValidators(Validators.required);
    }

    ctrl.updateValueAndValidity({ emitEvent: false });
  }

  private loadOsnovOdabiraProps() {
    this.shouldLabelBeAvans =
      this.form?.value.osnovOdabiraDokumenta ===
      PdvEvidencijaOsnovOdabiraDokumenta.AVANS;

    this.shouldDisplayNabavkaBN =
      this.form?.value.osnovOdabiraDokumenta ===
      PdvEvidencijaOsnovOdabiraDokumenta.PROMET;
  }

  handleSave() {
    // check is it valid
    if (!this.form!.valid) {
      this._formHelper.invalidateForm(this.form!);
      this._pdvPojedinacnaService.setFormSaveClicked = true;
      return;
    }

    // check at least one group(opis, osnovica, obracunatiPDV) is present
    if (!this._fs.areOsnovicaGroupsValid()) {
      this._alert.addWarnMsg(
        "Potrebno je popuniti 'Opis', 'Osnovica' i 'Obračunati PDV' u barem jednoj sekciji."
      );
      return;
    }

    // check if some obj and nonObj props are both (opis, osnovica, obracunatiPDV) present
    if (this._fs.hasObjAndNotObjProps()) {
      this._alert.addWarnMsg(
        "PDV evidencija ne sme sadržati istovremeno vrednosti koje se odnose i koje se ne odnose na promet nekretnina"
      );
      return;
    }

    if (this.isKoriguj) {
      this._sharedService.displayLoadingScreen(
        true,
        'Korigovanje pojedinačne pdv evidencije...'
      );
      this._subs.add(
        this._client
          .sefKorigujPdvEvidencijaPojedinacna39(
            this.form!.value.id!,
            this.form!.value as SefKorigujPdvEvidencijaPojedinacna39Command
          )
          .pipe(
            finalize(() => {
              this._sharedService.resetLoadingScreen();
            })
          )
          .subscribe((res) => {
            if (res.succeeded) {
              this._alert.addSuccessMsg(res.data!);
              this._locationService.routeBack();
            }
            this._alert.addFailedMsg(res.messages![0]);
          })
      );
    } else if (this._fs.jeEdit) {
      this._sharedService.displayLoadingScreen(
        true,
        'Ažuriranje pojedinačne pdv evidencije...'
      );
      // privremeno resenje dok ne uvedemo automatsko presabiranje
      this.form?.controls.obracunatPdv?.patchValue(
        this._getUkupnoObracunatPdv()
      );
      this._subs.add(
        this._client
          .updatePojedinacna39(
            this.form!.value.id!,
            this.form!.value as UpdatePdvEvidencijaPojedinacna39Command
          )
          .pipe(
            finalize(() => {
              this._sharedService.resetLoadingScreen();
            })
          )
          .subscribe((res) => {
            if (res.succeeded) {
              this._alert.addSuccessMsg(res.data!);
              this._locationService.routeBack();
            }
            this._alert.addFailedMsg(res.messages![0]);
          })
      );
    } else {
      this._sharedService.displayLoadingScreen(
        true,
        'Kreiranje pojedinačne pdv evidencija...'
      );
      // privremeno resenje dok ne uvedemo automatsko presabiranje
      this.form?.controls.obracunatPdv?.patchValue(
        this._getUkupnoObracunatPdv()
      );
      this._subs.add(
        this._client
          .createPojedinacna39(
            this.form!.value as CreatePdvEvidencijaPojedinacna39Command
          )
          .pipe(
            finalize(() => {
              this._sharedService.resetLoadingScreen();
            })
          )
          .subscribe((res) => {
            if (res.succeeded) {
              this._alert.addSuccessMsg(res.data!);
              this._locationService.routeBack();
            }
            this._alert.addFailedMsg(res.messages![0]);
          })
      );
    }
  }

  handleCancel() {
    this._confirmationService.confirm({
      message: 'Ukoliko otkažete sav nesnimljen sadržaj će biti izgubljen.',
      acceptLabel: 'Otkaži',
      rejectLabel: 'Ostani na stranici',
      header: 'Potvrdite otkazivanje',
      icon: 'far fa-check-circle',
      rejectButtonStyleClass: 'p-button-outlined',
      accept: () => {
        this._locationService.routeToCancelPdvEvidencija();
      },
    });
  }

  handleRouteBack() {
    this._locationService.routeBack();
  }

  handleAvansniVanSefaClick() {
    let value = this.avansniVanSefaInput.nativeElement.value;

    if (value.length === 0) {
      this._alert.addWarnMsg('Broj dokumenta ne sme biti prazan');
      return;
    }

    (this.form!.controls.povezaniVanSefa as FormArray).push(
      new FormControl(value, { validators: [Validators.required] })
    );
    this.avansniVanSefaInput.nativeElement.value = '';
  }

  handleVezaniRacunChange(vezaniRacun: IVezaniRacunDto) {
    (this.form!.controls.povezaniRacuni as FormArray).push(
      this._vezaniRacunFS.getFormGroup(vezaniRacun)
    );
  }

  onPrometChange(event: any) {
    this._pdvPojedinacnaService.setIsIsporuka =
      event.value === VrstaRacuna.IZLAZNI;

    this.shouldLabelBeAvans = false;

    this._fs.resetOnIsporukaNabavkaChange(
      this._pdvPojedinacnaService.getIsIsporuka
    );
    this._fs.resetOsnovniPodaci();

    this._fs.resetVezaneRacune();
    this.disabledTipPovezanog = false;
    this._pdvPojedinacnaService.changeTipPovezanog();
  }

  onTipDokumentaChange(event: any) {
    this._pdvPojedinacnaService.setTipDokumentaSubject = event.value;

    this.shouldDisplayIsporukaBN = event.value === PdvEvidencijaTipDokumenta.FAKTURA;

    this._checkShouldDisableAvansLabelIsporuka(event, false);

    if (event.value !== PdvEvidencijaTipDokumenta.AVANSNA_FAKTURA) {
      this._fs.resetDatumAvansa();
      this._fs.resetDokumentAndStranka();
    } else {
      this.form?.controls.tipPovezaneFakture?.patchValue(
        PdvEvidencijaTipPovezaneFakture.EMPTY
      );
    }
    this.disabledTipPovezanog = false;
    this._fs.resetOsnovniPodaci();
    this._fs.resetVezaneRacune();
    this._pdvPojedinacnaService.changeTipPovezanog();

    if(this._pdvPojedinacnaService.getIsIsporuka){
      this._fs.resetNonBnProps();
      return;
    }
    this._fs.resetAllProps();
  }

  onTipPovezanogDokumentaChange(event: any) {
    this._pdvPojedinacnaService.setIsAvansni =
      event.value === PdvEvidencijaTipPovezaneFakture.AVANSNA_FAKTURA;

    this._checkShouldDisableAvansLabelIsporuka(event, true);
  }

  private _checkShouldDisableAvansLabelIsporuka(
    event: any,
    isTipPovezanogChange: boolean
  ) {
    if (isTipPovezanogChange) {
      this.shouldLabelBeAvans =
        event.value === this.tipPovezaneFakture.AVANSNA_FAKTURA &&
        this.form?.value.tip === this.tipDokumenta.DOKUMENT_O_SMANJENJU;
      return;
    }

    this.shouldLabelBeAvans =
      event.value === this.tipDokumenta.AVANSNA_FAKTURA ||
      (event.value === this.tipDokumenta.DOKUMENT_O_SMANJENJU &&
        this.form?.value.tipPovezaneFakture ===
          this.tipPovezaneFakture.AVANSNA_FAKTURA);
  }

  private _checkShouldDisableAvansLabelNabavka(
    event: any,
    isTipPovezanogInternogChange: boolean
  ) {
    // event je tipPovezanogInternog
    if (isTipPovezanogInternogChange) {
      this.shouldLabelBeAvans =
        this.form!.value.osnovOdabiraDokumenta === this.osnovOdabira.SMANJENJE &&
        event.value === this.tipPovezanogInternog.INTERNI_RACUN_ZA_AVANS;

      return;
    }

    // event je osnov
    this.shouldLabelBeAvans =
      event.value === this.osnovOdabira.AVANS ||
      (event.value === this.osnovOdabira.SMANJENJE &&
        this.form?.value.tipPovezanogInternog ===
          this.tipPovezanogInternog.INTERNI_RACUN_ZA_AVANS);
  }

  private _avansLabelsInit(){
    if(this._pdvPojedinacnaService.getIsIsporuka){
      this._avansLabelsInitIsporuka();
      return;
    }

    this._avansLabelsInitNabavka();
  }

  private _avansLabelsInitIsporuka(){
    this.shouldLabelBeAvans =
      this._pdvPojedinacnaService.getTipDokumentaSubject ===
        this.tipDokumenta.AVANSNA_FAKTURA ||
      (this._pdvPojedinacnaService.getTipDokumentaSubject === this.tipDokumenta.DOKUMENT_O_SMANJENJU &&
        this.form?.value.tipPovezaneFakture ===
          this.tipPovezaneFakture.AVANSNA_FAKTURA);
  }

  private _avansLabelsInitNabavka(){
    this.shouldLabelBeAvans =
      this.form?.value.osnovOdabiraDokumenta === this.osnovOdabira.AVANS ||
      (this.form?.value.osnovOdabiraDokumenta === this.osnovOdabira.SMANJENJE &&
        this.form?.value.tipPovezanogInternog ===
          this.tipPovezanogInternog.INTERNI_RACUN_ZA_AVANS);
  }

  onOsnovaOdabiraChange(event: any) {
    this._pdvPojedinacnaService.setOsnovOdabira = event.value;

    this._checkShouldDisableAvansLabelNabavka(event, false);

    this.shouldDisplayNabavkaBN =
      event.value === PdvEvidencijaOsnovOdabiraDokumenta.PROMET;
    if (!this.shouldDisplayNabavkaBN) {
      this._fs.resetBNProps();
    }

    if (!this.shouldLabelBeAvans) {
      this._fs.resetDatumAvansa();
    }
  }

  onTipPovezanogInternogChange(event: any) {
    this._pdvPojedinacnaService.setIsInterniZaAvans =
      event.value === PdvEvidencijaTipPovezanogInternog.INTERNI_RACUN_ZA_AVANS;

    this._checkShouldDisableAvansLabelNabavka(event, true);
  }

  private _getUkupnoObracunatPdv() {
    return (
      (this.form?.value.promet10?.obracunatiPdv ?? 0) +
      (this.form?.value.promet20?.obracunatiPdv ?? 0) +
      (this.form?.value.promet10Obj?.obracunatiPdv ?? 0) +
      (this.form?.value.promet20Obj?.obracunatiPdv ?? 0) +
      (this.form?.value.promet10Bn?.obracunatiPdv ?? 0) +
      (this.form?.value.promet20Bn?.obracunatiPdv ?? 0) +
      (this.form?.value.promet10BnObj?.obracunatiPdv ?? 0) +
      (this.form?.value.promet20BnObj?.obracunatiPdv ?? 0)
    );
  }


  ngOnDestroy(): void {
    this._fs.resetForm();
    this._pdvPojedinacnaService.setFormSaveClicked = false;
    this._subs.unsubscribe();
  }
}
